
import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class SuccessMessage extends Vue {
  @Prop({ required: false, default: "Success!" }) readonly title?: string
  @Prop({ default: "The operation was successful" }) readonly subTitle?: string
}
